import './Asterisk.scss';

const Asterisk = () => {
    return (<span className="asterisk">*</span>)
}

export {Asterisk}